import Skeleton from '@app.components/Skeleton'
import { AD_CODE_ID } from '@app.feature/ad/constants/adCode'
import useGetAdByPlacementCodeAndCurrentTime from '@app.feature/ad/hooks/useGetAdByPlacementCodeAndCurrentTime'
import CoverLetterSearchBannerMobile, {
  COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE,
} from './CoverLetterSearchBanner.mobile'

export const COVER_LETTER_MOBILE_AD_CODE = 'mobile-coverletter-search-banner'

const CoverLetterSearchBannerStatusMobile = () => {
  const { ad, loading, error } = useGetAdByPlacementCodeAndCurrentTime({
    code: AD_CODE_ID.COVER_LETTER_SEARCH.MOBILE!,
  })

  if (loading) {
    return (
      <Skeleton
        width="100%"
        height={COVER_LETTER_SEARCH_BANNER_MOBILE_IMAGE_SIZE.height}
      />
    )
  }

  if (!ad || error) {
    return null
  }

  return <CoverLetterSearchBannerMobile ad={ad} />
}

export default CoverLetterSearchBannerStatusMobile
